<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      highlight-current-row
      row-id="materialCategoryCode"
      :tree-config="treeConfig"
      border
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      @current-change="onCurrentChange"
      size="small"
      ref="xTree"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:materialCategoryStatus="{ row }">
        <el-tag
          size="mini"
          :type="row.materialCategoryStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.materialCategoryStatusName }}
        </el-tag>
      </template>
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  inject: ['materialQuery'],
  data() {
    return {
      tableHeight: 500,
      tableColumns: [
        {
          title: this.$l('INDEX.table_label_classification_name') || '分类名称',
          field: 'materialCategoryName',
          headerAlign: 'left',
          align: 'left',
          minWidth: '120px',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          treeNode: true,
        },
        {
          title:
            this.$l('INDEX.table_label_classification_nameEn') ||
            '分类名称英文',
          field: 'materialCategoryNameEn',
          headerAlign: 'left',
          align: 'left',
          minWidth: '120px',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
      ],
      treeConfig: {
        children: 'childs',
        line: true,
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
      },
    }
  },
  methods: {
    onCurrentChange({ row }) {
      this.materialQuery(row)
    },
    expandTree() {
      this.$refs.xTree.setAllTreeExpand(true)
    },
  },
}
</script>
